<template>
  <div class="hash-map-wrap">
    <!-- header -->
    <slot name="header"></slot>

    <div class="hash-map-wrap__content__wrap__label" v-if="showLabel">
      <label
        v-for="r in rules"
        :key="r.key"
        :style="{ width: `${r.width || 200}px` }"
        >{{ r.key }}</label
      >
    </div>

    <!-- conditions -->
    <ul class="hash-map-wrap__content">
      <li
        class="hash-map-wrap__content__item__wrap"
        v-for="(condition, index) in mapList"
        :key="index"
      >
        <div
          class="hash-map-wrap__content__wrap__item"
          v-for="rule in rules"
          :key="rule.key"
          :style="{ width: `${rule.width || 200}px` }"
        >
          <zm-select
            v-if="rule.type === 'select'"
            style="width: 100%"
            :placeholder="rule.placeHolder || 'Select'"
            v-model="condition[rule.key]"
            popper-append-to-body
          >
            <zm-option
              v-for="s in rule.options"
              :option-id="s.value"
              :label="s.label"
              :value="s.value"
              :key="s.label"
            />
          </zm-select>
          <zm-input
            v-else
            v-model="condition[rule.key]"
            style="width: 100%"
            :placeholder="rule.placeHolder || ''"
          ></zm-input>
        </div>
        <zm-button
          class="hash-map-wrap__content__wrap__delete"
          icon="zm-icon-delete-outline"
          @click="handleDeleteCondition(index)"
        />
      </li>
    </ul>

    <!-- add button -->
    <zm-button
      type="primary"
      ghost
      icon="zm-icon-add"
      @click="handleAddCondition"
    >
      Add
    </zm-button>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash-es'
export default {
  name: 'AsRuleMap',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    rules: {
      type: Array,
      default: () => []
    },
    showLabel: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    mapList: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  created() {
    this.initValue()
  },
  methods: {
    initValue() {
      if (this.value.length === 0) {
        const emptyValue = this.getEmptyItemValue()
        this.$emit('input', [emptyValue])
      }
    },
    handleDeleteCondition(index) {
      const list = cloneDeep(this.mapList)
      list.splice(index, 1)
      this.mapList = list
    },
    getEmptyItemValue() {
      return this.rules.reduce((previous, current) => {
        const { key, type } = current
        previous[key] = type === 'select' ? [] : ''
        return previous
      }, {})
    },
    handleAddCondition() {
      const list = cloneDeep(this.mapList)
      const emptyValue = this.getEmptyItemValue()
      list.push(emptyValue)
      this.mapList = list
    }
  }
}
</script>

<style scoped lang="scss">
.hash-map-wrap {
  background: #f7f9fa;
  border-radius: 12px;
  padding: 12px;

  .hash-map-wrap__content__wrap__label {
    label {
      display: inline-block;
      margin-right: 8px;
      color: #131619;
      font-weight: 500;
    }
  }

  .hash-map-wrap__content {
    padding: 0;
    margin: 6px 0;
    .hash-map-wrap__content__item__wrap {
      list-style-type: none;
      margin-bottom: 8px;
      .hash-map-wrap__content__wrap__item {
        margin-right: 8px;
        display: inline-block;
      }
      .hash-map-wrap__content__wrap__delete {
        margin-left: 8px;
      }
    }
  }
}
</style>
